var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.db.config.inited,
          expression: "db.config.inited"
        }
      ],
      staticClass: "Index"
    },
    [
      _c(
        "div",
        { staticClass: "ui text container segment InputPanels" },
        [
          _c("h1", { staticClass: "ui horizontal divider header" }, [
            _vm._v(
              "\r\n      " +
                _vm._s(_vm.$t("Sign-In Sheet Generator")) +
                "\r\n    "
            )
          ]),
          _vm._v(" "),
          _c("InputPanel", { ref: "InputPanel", attrs: { db: _vm.db } })
        ],
        1
      ),
      _vm._v(" "),
      _c("PrintComponent", { ref: "PrintComponent", attrs: { db: _vm.db } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }